<template>
  <div class="payment-card">
    <p class="payment-title">Thank you for your donation</p>
    <p class="payment-title-sub">{{ payments.paymentMessage }}</p>

    <p class="ico">
      <span>
        <img
          src="https://rubies-ibank-test-two.s3-us-west-2.amazonaws.com/img/new-rubies/donate.rubies.com/recived.png"
          alt="Payment Not Received"
        />
      </span>
    </p>
    <div class="action">
      <span @click="finishPayment" class="app-btn">Close</span>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "NoPaymentReceivedCard",
  computed: {
    ...mapState(["payments"])
  },
  methods: {
    finishPayment() {
      this.$store.dispatch("payments/showPaymentsReceivedModal", false, {
        root: true
      });
      this.$store.dispatch("donation/getDonationsStats", null, { root: true });
    }
  }
};
</script>

<style scoped></style>
